import slide1Desktop from '../../src/assets/img/sweepstakes/virtualTour/virtual-tour-slide-1-desktop.png';
import slide1Mobile from '../../src/assets/img/sweepstakes/virtualTour/virtual-tour-slide-1-mobile.png';
import slide1Tablet from '../../src/assets/img/sweepstakes/virtualTour/virtual-tour-slide-1-tablet.png';
import slide2Desktop from '../../src/assets/img/sweepstakes/virtualTour/virtual-tour-slide-2-desktop.png';
import slide2Mobile from '../../src/assets/img/sweepstakes/virtualTour/virtual-tour-slide-2-mobile.png';
import slide2Tablet from '../../src/assets/img/sweepstakes/virtualTour/virtual-tour-slide-2-tablet.png';
import slide3Desktop from '../../src/assets/img/sweepstakes/virtualTour/virtual-tour-slide-3-desktop.png';
import slide3Mobile from '../../src/assets/img/sweepstakes/virtualTour/virtual-tour-slide-3-mobile.png';
import slide3Tablet from '../../src/assets/img/sweepstakes/virtualTour/virtual-tour-slide-3-tablet.png';
import slide4Desktop from '../../src/assets/img/sweepstakes/virtualTour/virtual-tour-slide-4-desktop.png';
import slide4Mobile from '../../src/assets/img/sweepstakes/virtualTour/virtual-tour-slide-4-mobile.png';
import slide4Tablet from '../../src/assets/img/sweepstakes/virtualTour/virtual-tour-slide-4-tablet.png';
import slide5Desktop from '../../src/assets/img/sweepstakes/virtualTour/virtual-tour-slide-5-desktop.png';
import slide5Mobile from '../../src/assets/img/sweepstakes/virtualTour/virtual-tour-slide-5-mobile.png';
import slide5Tablet from '../../src/assets/img/sweepstakes/virtualTour/virtual-tour-slide-5-tablet.png';

const virtualTourConfiguration = [
  {
    id: 1,
    header: 'Welcome to Lucky Lounge!',
    body: 'Lucky Lounge is a place to play and win online! Play digital games, earn tokens, then enter to win Lucky Lounge cash drawings.',
    image: slide1Desktop,
    imageTablet: slide1Tablet,
    imageMobile: slide1Mobile
  },
  {
    id: 2,
    header: 'Tokens Are Currency',
    body: `Buy tokens in the Lucky Lounge, earn tokens by playing games, or convert Players Club Points to tokens. Then start playing!`,
    image: slide2Desktop,
    imageTablet: slide2Tablet,
    imageMobile: slide2Mobile
  },
  {
    id: 3,
    header: 'Lucky Lounge Games',
    body: `Select a game to play in the Lucky Lounge. You can see how many tokens you can earn and how many tokens it takes to play.`,
    image: slide3Desktop,
    imageTablet: slide3Tablet,
    imageMobile: slide3Mobile
  },
  {
    id: 4,
    header: 'Sweepstakes Drawings',
    body: `Use tokens to enter weekly, bi-weekly, monthly, and quarterly sweepstakes drawings for a chance to win cash prizes!`,
    image: slide4Desktop,
    imageTablet: slide4Tablet,
    imageMobile: slide4Mobile
  },
  {
    id: 5,
    header: 'Lucky Lounge History',
    body: `Your History shows all points exchanges, game plays, and drawings entered. Token balances appear on every page in Lucky Lounge. `,
    image: slide5Desktop,
    imageTablet: slide5Tablet,
    imageMobile: slide5Mobile,
    buttonText: 'Play'
  }
];

export default virtualTourConfiguration;
